import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {BottomMessageModuleController} from "../bottom-message-module.controller";

export class BottomMessageModuleProps extends BaseModuleProps {
  controller: BottomMessageModuleController;
}
